var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.648 8.228a3.061 3.061 0 0 1 1.13-2.378L45.741.3a1.352 1.352 0 0 1 1.812.1 1.57 1.57 0 0 1 .221 1.912l-4.757 7.813a2.818 2.818 0 0 1-1.977 1.344zm2.824 4.272a3.4 3.4 0 0 1-3.295 3.5h-4.236a1 1 0 0 1 0-2h.141c.519 0 .87-.591.817-1.138a3.958 3.958 0 0 1-.017-.363A3.412 3.412 0 0 1 37.051 9l3.415 3.263c0 .05.006.156.006.234z",
    fill: "currentColor",
    transform: "translate(-32)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintIcon);
export default __webpack_public_path__ + "static/media/paint-icon.ac02e0a02de9ee2dc4f38a852e62bbca.svg";
export { ForwardRef as ReactComponent };